// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5793":"c4cd48cfc6939c5a","8969":"0db0dcb63964e2b7"}[chunkId] + ".css";
};